(function () {
  var MAX = 4;
  var compareList = [];

  var compareBar = document.getElementById('compare-bar');
  var compareCount = document.getElementById('compare-count');
  var compareBarItems = document.getElementById('compare-bar-items');
  var compareOpenBtn = document.getElementById('compare-open-btn');
  var compareClearBtn = document.getElementById('compare-clear-btn');
  var compareModal = document.getElementById('compare-modal');
  var compareOverlay = document.getElementById('compare-overlay');
  var compareClose = document.getElementById('compare-close');
  var compareGrid = document.getElementById('compare-grid');

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function stripHtml(html) {
    var div = document.createElement('div');
    div.innerHTML = html || '';
    return div.textContent || div.innerText || '';
  }

    function updateBar() {
      if (!compareBar) return;

      compareBar.hidden = compareList.length === 0;
      compareCount.textContent = compareList.length;
      compareBarItems.innerHTML = '';

      compareList.forEach(function (p) {
        var item = document.createElement('div');
        item.className = 'compare-bar-item';

        item.innerHTML =
          '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '">' +
          '<button type="button" data-remove-compare ' +
          'data-product-id="' + escapeHtml(p.id) + '">×</button>';

        compareBarItems.appendChild(item);
      });

      document.querySelectorAll('[data-compare]').forEach(function (btn) {
        var id = btn.getAttribute('data-product-id');
        var inList = compareList.some(function (p) {
          return p.id === id;
        });

        btn.classList.toggle('is-active', inList);
      });
    }

  function openCompareModal() {
    if (compareList.length < 2) return;
    renderCompareGrid();
    compareModal.classList.add('is-open');
    compareOverlay.classList.add('is-open');
    compareModal.setAttribute('aria-hidden', 'false');
  }

  function closeCompareModal() {
    compareModal.classList.remove('is-open');
    compareOverlay.classList.remove('is-open');
    compareModal.setAttribute('aria-hidden', 'true');
  }

      function renderCompareGrid() {
        var columnCount = Math.min(compareList.length, MAX);

        compareGrid.style.setProperty(
          '--compare-columns',
          columnCount
        );

        var fields = [
          { label: 'Price', key: 'price' },
          { label: 'H x W x D', key: 'dimensions' }
        ];

        var html = '';

        compareList.forEach(function (p) {
          html += '<div class="compare-col">';

          html +=
            '<button type="button" class="compare-col-remove" ' +
            'data-remove-from-modal ' +
            'data-product-id="' + escapeHtml(p.id) + '">' +
            '×' +
            '</button>';

          html +=
            '<img class="compare-col-image" ' +
            'src="' + escapeHtml(p.image) + '" ' +
            'alt="' + escapeHtml(p.title) + '">';

          html +=
            '<div class="compare-col-title">' +
            '<a href="/products/' + escapeHtml(p.handle) + '">' +
            escapeHtml(p.title) +
            '</a>' +
            '</div>';

          fields.forEach(function (f) {
            var value = p[f.key] || '—';

            if (f.key === 'price') {
              value = stripHtml(value);
            }

            html += '<div class="compare-col-row">';
            html +=
              '<span class="compare-col-label">' +
              escapeHtml(f.label) +
              '</span>';
            html +=
              '<span class="compare-col-value">' +
              escapeHtml(value) +
              '</span>';
            html += '</div>';
          });

          html +=
            '<button type="button" ' +
            'class="compare-col-add" ' +
            'data-variant-id="' + escapeHtml(p.variantId) + '" ' +
            'data-quick-add-compare>' +
            'Add to Cart' +
            '</button>';

          html += '</div>';
        });

        compareGrid.innerHTML = html;
      }

  // 事件代理
  document.addEventListener('click', function (e) {
    // 加入/移除比較
    var compareBtn = e.target.closest('[data-compare]');
    if (compareBtn) {
      e.preventDefault();
      var id = compareBtn.getAttribute('data-product-id');
      var inList = compareList.some(function (p) { return p.id === id; });

      if (inList) {
        compareList = compareList.filter(function (p) { return p.id !== id; });
      } else {
        if (compareList.length >= MAX) {
          alert('You can compare up to ' + MAX + ' products.');
          return;
        }
        
          compareList.push({
          id: id,
          handle: compareBtn.getAttribute('data-product-handle'),
          title: compareBtn.getAttribute('data-product-title'),
          image: compareBtn.getAttribute('data-product-image'),
          price: compareBtn.getAttribute('data-product-price'),
          dimensions: compareBtn.getAttribute('data-product-dimensions'),
          variantId: compareBtn.getAttribute('data-variant-id')
        });
      }
      updateBar();
      return;
    }

    // 從 bar 移除
    var removeBtn = e.target.closest('[data-remove-compare]');
    if (removeBtn) {
      var rid = removeBtn.getAttribute('data-product-id');
      compareList = compareList.filter(function (p) { return p.id !== rid; });
      updateBar();
      return;
    }

    // 開啟 modal
    if (e.target.closest('#compare-open-btn')) {
      openCompareModal();
      return;
    }

    // 清除全部
    if (e.target.closest('#compare-clear-btn')) {
      compareList = [];
      updateBar();
      return;
    }

    // Modal 內移除單一商品
      var removeFromModal = e.target.closest('[data-remove-from-modal]');

      if (removeFromModal) {
        var mid = removeFromModal.getAttribute('data-product-id');

        compareList = compareList.filter(function (p) {
          return p.id !== mid;
        });

        updateBar();

        if (compareList.length < 2) {
          closeCompareModal();
        } else {
          renderCompareGrid();
        }

        return;
      }

    // 關閉 modal
    if (e.target.closest('#compare-close') || e.target === compareOverlay) {
      closeCompareModal();
      return;
    }

    // Modal 內加入購物車
    var addBtn = e.target.closest('[data-quick-add-compare]');
    if (addBtn) {
      var variantId = addBtn.getAttribute('data-variant-id');
      if (!variantId) return;
      addBtn.disabled = true;
      addBtn.textContent = '…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          addBtn.textContent = '✓ Added';
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
          setTimeout(function () {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Cart';
          }, 1500);
        })
        .catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to Cart';
        });
    }
  });
})();
